// Card compartilhável (PNG) do dashboard de emissões (PO1-2402).
// Desenhado à mão em <canvas> nativo (sem dependência DOM→imagem), 1080×1080,
// com o período/filtros selecionados. Tom "pegada medida", nunca "neutro".
import {
  TITULO_ESG,
  SUBTITULO_ESG,
  FONTE_EQUIVALENCIAS,
  EQUIVALENCIA_LABELS,
  calcularEquivalencias,
  notaCobertura,
} from "./equivalencias";

const TAM = 1080;
const PAD = 80;
const AZUL = "#1d8cf8"; // COR_PRIMARIA
const FUNDO = "#1b243b";
const BRANCO = "#ffffff";
const CINZA = "#9aa5c0";

const fontFamily =
  '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif';

const numPt = (n, frac = 0) =>
  Number(n || 0).toLocaleString("pt-BR", {
    minimumFractionDigits: frac,
    maximumFractionDigits: frac,
  });

function quebrarTexto(ctx, texto, maxLargura) {
  const palavras = String(texto || "").split(" ");
  const linhas = [];
  let atual = "";
  palavras.forEach((p) => {
    const teste = atual ? `${atual} ${p}` : p;
    if (ctx.measureText(teste).width > maxLargura && atual) {
      linhas.push(atual);
      atual = p;
    } else {
      atual = teste;
    }
  });
  if (atual) linhas.push(atual);
  return linhas;
}

// Desenha o card e resolve com um Blob PNG.
export function desenharCardPng(data, contexto = {}) {
  const { periodoLabel = "-" } = contexto;
  const k = (data && data.kpis) || {};
  const eq = calcularEquivalencias(k.totalToneladasCO2);

  const canvas = document.createElement("canvas");
  canvas.width = TAM;
  canvas.height = TAM;
  const ctx = canvas.getContext("2d");

  // Fundo + barra de destaque.
  ctx.fillStyle = FUNDO;
  ctx.fillRect(0, 0, TAM, TAM);
  ctx.fillStyle = AZUL;
  ctx.fillRect(0, 0, TAM, 14);

  ctx.textBaseline = "alphabetic";

  // Título / subtítulo / período.
  ctx.fillStyle = BRANCO;
  ctx.font = `700 58px ${fontFamily}`;
  ctx.fillText(TITULO_ESG, PAD, 150);
  ctx.fillStyle = CINZA;
  ctx.font = `400 30px ${fontFamily}`;
  ctx.fillText(SUBTITULO_ESG, PAD, 196);
  ctx.fillText(`Período: ${periodoLabel}`, PAD, 250);

  // Divisor.
  ctx.strokeStyle = "rgba(255,255,255,0.12)";
  ctx.lineWidth = 2;
  ctx.beginPath();
  ctx.moveTo(PAD, 285);
  ctx.lineTo(TAM - PAD, 285);
  ctx.stroke();

  // Número principal (total t CO₂).
  ctx.fillStyle = AZUL;
  ctx.font = `700 132px ${fontFamily}`;
  ctx.fillText(numPt(k.totalToneladasCO2, 1), PAD, 430);
  ctx.fillStyle = BRANCO;
  ctx.font = `400 34px ${fontFamily}`;
  ctx.fillText("t CO₂ medidas no período", PAD, 478);

  // KPIs secundários.
  ctx.fillStyle = CINZA;
  ctx.font = `400 28px ${fontFamily}`;
  ctx.fillText(
    `${numPt(k.qtdCtes)} CT-es com pegada calculada`,
    PAD,
    540
  );
  ctx.fillText(`${numPt(k.distanciaTotalKm)} km percorridos`, PAD, 578);

  // Equivalências.
  ctx.fillStyle = BRANCO;
  ctx.font = `700 32px ${fontFamily}`;
  ctx.fillText("Equivale a", PAD, 650);
  ctx.font = `400 30px ${fontFamily}`;
  const linhasEq = [
    `≈ ${numPt(eq.arvores)} ${EQUIVALENCIA_LABELS.arvores}`,
    `≈ ${numPt(eq.carros)} ${EQUIVALENCIA_LABELS.carros}`,
    `≈ ${numPt(eq.voos)} ${EQUIVALENCIA_LABELS.voos}`,
    `≈ ${numPt(eq.gasolina)} ${EQUIVALENCIA_LABELS.gasolina}`,
  ];
  linhasEq.forEach((linha, i) => ctx.fillText(linha, PAD, 700 + i * 44));

  // Nota de cobertura (anti-greenwashing).
  let y = 900;
  const nota = notaCobertura(data && data.cobertura);
  if (nota) {
    ctx.fillStyle = CINZA;
    ctx.font = `400 24px ${fontFamily}`;
    quebrarTexto(ctx, nota, TAM - PAD * 2).forEach((linha) => {
      ctx.fillText(linha, PAD, y);
      y += 32;
    });
  }

  // Rodapé de fontes.
  ctx.fillStyle = "rgba(154,165,192,0.75)";
  ctx.font = `400 20px ${fontFamily}`;
  let yf = TAM - 96;
  quebrarTexto(ctx, FONTE_EQUIVALENCIAS, TAM - PAD * 2).forEach((linha) => {
    ctx.fillText(linha, PAD, yf);
    yf += 26;
  });

  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (blob) resolve(blob);
      else reject(new Error("Falha ao gerar o PNG do card."));
    }, "image/png");
  });
}

export async function baixarCardPng(data, contexto = {}) {
  const { desde = "periodo", ate = "" } = contexto;
  const blob = await desenharCardPng(data, contexto);
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = `card-esg-${desde}-a-${ate}.png`;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
}
